export default {
  data: {}
}



// WEBPACK FOOTER //
// ./src/store/modules/client/state.js